// frontend/src/components/Network/ConnectionCard.jsx
import React from 'react';
import './ConnectionCard.css';
import ReadableText from '../ReadableText';
import { useI18n } from '../../i18n';

const ConnectionCard = ({ user, onUnfollow }) => {
  const { t } = useI18n();
  const { handle, displayName, avatar, avatar_url, bio_snippet, is_mutual, intensity } = user;

  const renderAvatar = (av) => {
    const cleanAv = av === '/default-avatar.png' ? null : av;
    if (!cleanAv) return '👤';
    if (cleanAv.startsWith('http')) {
      return <img src={cleanAv} alt="avatar" className="conn-avatar-img" referrerPolicy="no-referrer" />;
    }
    return <span className="conn-avatar-emoji">{cleanAv}</span>;
  };

  return (
    <div className={`connection-card ${is_mutual ? 'is-mutual' : ''}`}>
      {renderAvatar(avatar || avatar_url)}

      <div className="conn-info">
        <span className="conn-name">{displayName || handle}</span>
        <span className="conn-handle">@{handle}</span>
        <span className="conn-bio"><ReadableText text={bio_snippet} label={t('network.readBio')}>{bio_snippet}</ReadableText></span>

        {is_mutual && intensity && (
          <div className="conn-intensity">
            <div className="intensity-bar">
              <div
                className="intensity-fill"
                style={{ width: `${intensity.score}%` }}
              />
            </div>
            <p className="intensity-text">
              <ReadableText text={intensity.summary} label={t('network.readConnectionSynthesis')}>
                {intensity.summary}
              </ReadableText>
            </p>
          </div>
        )}
      </div>

      <div className="conn-actions">
        {is_mutual && <div className="conn-mutual-badge" title={t('network.mutualConnection')} />}
        <button
          className="unfollow-btn"
          onClick={() => onUnfollow(handle)}
        >
          {t('common.disconnect')}
        </button>
      </div>
    </div>
  );
};

export default ConnectionCard;
